<template>
  <div class="iframe">
    <div v-show="!is_login" style="margin-top:18px;">
      <a rel="nofollow" href="/login" class="btn_login" target="_top">登录</a>
      <a href="/register" class="reg_btn">注册</a>
    </div>
    <div v-show="is_login" style="margin-top:18px;">
      <router-link to="/profile" target="_top" class="nickname" :title="nickname">{{ nickname }}</router-link>
      <router-link to="/logout" class="logout">退出登录</router-link>
    </div>
  </div>
</template>
<script>
import { session, api, config } from "@/assets/js/util.js";
export default {
  name: "SiteToper",
  inject: ["global"],
  data() {
    return {
      is_login: false,
      nickname: "",
    };
  },
  mounted() {
    this.is_login = config.get("is_login");
    this.nickname = config.get("nickname");
  },
  methods: {

  },
};
</script>
<style>
.iframe a.btn_login {
  font-size: 14px;
  color: #666666;
  line-height: 2.4em;
  font-weight: normal;
  font-style: normal;
  text-align: center;
  width: 60px;
  border-radius: 4px;
  border: 1px solid #DDDDDD;
  display: inline-block;
  text-decoration: none;
}

.iframe a.reg_btn {
  display: inline-block;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 2.4em;
  font-weight: normal;
  font-style: normal;
  text-align: center;
  width: 60px;
  border-radius: 4px;
  border: 1px solid #00A1E7;
  background: #00A1E7;
  margin-left: 15px;
  text-decoration: none;
}

.iframe .nickname {
  text-decoration: none;
  color: #666666;
  word-wrap: break-word;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  /* 隐藏溢出的内容 */
  text-overflow: ellipsis;
  /* 显示省略符号 */
}

.iframe .logout {
  font-size: 14px;
  text-decoration: none;
  color: #cd1010;
  word-wrap: break-word;
  margin-left: 15px;
}

body {
  margin: 0;
}
</style>
